import { render, staticRenderFns } from "./serviceRenewList.vue?vue&type=template&id=5ddf09d0&scoped=true&"
import script from "./serviceRenewList.vue?vue&type=script&lang=js&"
export * from "./serviceRenewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddf09d0",
  null
  
)

export default component.exports